import { HTMLAttributes, forwardRef } from 'react';
import { ReactComponent as HelpIcon } from 'src/Themes/assets/info.svg';
import st from './HelpHint.module.scss';
import { Hint } from '@redoc/ui-kit';

interface IHelpHintProps extends HTMLAttributes<HTMLSpanElement> {
	disable?: boolean;
	variant?: 'white' | 'gray';
}

const HelpHint = forwardRef<HTMLSpanElement, IHelpHintProps>(
	({ title, variant = 'gray', disable = false, ...otherProps }, ref) => {
		return (
			<Hint placement="top" messageText={title}>
				<span ref={ref} tabIndex={-1} {...otherProps}>
					<HelpIcon className={st.hintIcon} tabIndex={-1} />
				</span>
			</Hint>
		);
	},
);

export default HelpHint;
